import React, { useEffect, useState, useRef } from 'react';
import { fetchData } from '../utils/apiHelpers';
import { getAll } from '../api';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import Select from 'react-select';
import {
  createPriority,
  updatePriority,
  deletePriority,
  getPriority
} from '../api/priorityAPI';

const PriorityListLayer = () => {
  const userProfile = useUserProfile();
  const [priorityList, setPriorityList] = useState([]);
  const [colours, setColourList] = useState([]);
  const [newPriority, setNewPriority] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const colourOptions = colours.map(c => ({
    value: c.id,
    label: c.name,
    bootstrapName: c.bootstrapName,
  }));

  // Load all priorities initially
  const fetchPriorities = () => {
    fetchData(getPriority, {}, setPriorityList);
  };


   const validateForm = () => {
    const newErrors = {};
    if (!newPriority.name?.trim()) newErrors.name = 'Priority is required';
    if (
      !Number.isInteger(newPriority.requiredByDays) ||
      newPriority.requiredByDays <= 0
    ) {
      newErrors.requiredByDays = 'Order Lead Time must be a positive integer';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
      fetchPriorities();
      fetchData(getAll, {apiName: 'colours' }, setColourList);
  }, []);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.destroy();
      dtRef.current = null;
    }
    if (priorityList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({
        pageLength: 25,
        dom: 'rtp',
        responsive: false,
        language: {
          paginate: { first: '', last: '', next: '', previous: '' },
        },
      });
    }
    return () => {
      if (dtRef.current) {
        dtRef.current.destroy(true);
        dtRef.current = null;
      }
    };
  }, [priorityList]);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.search(searchTerm).draw();
    }
  }, [searchTerm]);

  // Handle inputs in the modal form
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPriority((prev) => ({
      ...prev,
      [name]:
        name === 'requiredByDays'
          ? value === ''
            ? ''
            : parseInt(value, 10)
          : value,
    }));
  };

  // Edit
  const handleEdit = (item) => {
    setNewPriority(item);
    setEditingId(item.id);
    setShowModal(true);
  };
    
  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this priority?')) return;
    try {
      await deletePriority(id);
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }
      await fetchPriorities();
    } catch (error) {
      console.error('Error deleting priority:', error);
    }
  };

  // Save or update
  const handleSave = async () => {
    if (!validateForm()) return;
      try {
      // strip out any null or object values from newAsset response
      const cleanPayload = {};
      for (const key in newPriority) {
        if (newPriority[key] !== null && typeof newPriority[key] !== 'object') {
          cleanPayload[key] = newPriority[key];
        }
      }

      if (editingId) {
        await updatePriority(editingId, cleanPayload);
      } else {
        await createPriority(cleanPayload);
      }

      setShowModal(false);
      setEditingId(null);

      // repaint the table
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }

      setNewPriority({});

      await fetchPriorities();
    } catch (error) {
      console.error('Error saving priority:', error);
    }
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between align-items-center p-3">
      <div className="d-flex align-items-center flex-wrap gap-3">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {userProfile?.privileges?.includes('priority:create') && (
        <button
          className="btn btn-primary text-sm btn-sm px-16 py-12 radius-4 d-flex align-items-center gap-2"
          onClick={() => {
            setNewPriority({});
            setEditingId(null);
            setShowModal(true);
          }}
        >
          <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" /> 
          Add Priority
        </button>
      )}
      </div>

      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table mb-0 w-100 rounded-0" ref={tableRef}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Colour Code</th>
                <th>Order Lead Time (Days)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {priorityList.map((item) => (
                <tr key={item.id}>
                  <td><strong>{item.name}</strong></td>
                  <td style={{ verticalAlign: 'middle' }}>
                    <span
                      className={`d-inline-block rounded-1 bg-${item.colours.bootstrapName}`}
                      style={{ width: '10px', height: '10px', marginRight: '8px' }}
                    ></span>
                    {item.colours.name}
                  </td>
                  <td>{item.requiredByDays}</td>
                  <td>
                    <div className="d-flex gap-2">
                    {userProfile?.privileges?.includes('priority:update') && (
                      <button
                        className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        onClick={() => handleEdit(item)}
                      >
                        <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                      </button>
                    )}
                    {userProfile?.privileges?.includes('priority:delete') && (
                      <button
                        className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        onClick={() => handleDelete(item.id)}
                      >
                        <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                      </button>
                    )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Priority' : 'New Priority'}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  {/* Name */}
                  <div className="col-md-6">
                    <label className="form-label">Priority Name *</label>
                    <input
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      name="name"
                      value={newPriority.name || ''}
                      onChange={handleInputChange}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                  </div>

                    {/* Colour Code */}
                    <div className="col-md-6">
                      <label className="form-label">Colour Code *</label>
                      <Select
                        name="coloursId"
                        className="react-select-container"
                        classNamePrefix={`react-select ${errors.coloursId ? 'is-invalid' : ''}`}
                        value={colourOptions.find(option => option.value === newPriority.coloursId) || null}
                        onChange={(selectedOption) =>
                          handleInputChange({ target: { name: 'coloursId', value: selectedOption?.value || '' } })
                        }
                        options={colourOptions}
                        isClearable
                        placeholder="Select Colour"
                        formatOptionLabel={(option) => (
                          <div className="d-flex align-items-center gap-2">
                            <span
                              className={`d-inline-block rounded-1 bg-${option.bootstrapName}`}
                              style={{ width: '10px', height: '10px' }}
                            ></span>
                            {option.label}
                          </div>
                        )}
                      />
                      {errors.coloursId && <div className="react-select-invalid">{errors.coloursId}</div>}
                    </div>

                    {/* Order Lead Time */}
                    <div className="col-md-6">
                      <label className="form-label">Order Lead Time (Days) *</label>
                      <input
                        type="number"
                        min="1"
                        className={`form-control ${errors.requiredByDays ? 'is-invalid' : ''}`}
                        name="requiredByDays"
                        value={newPriority.requiredByDays || ''}
                        onChange={handleInputChange}
                      />
                      {errors.requiredByDays && (
                        <div className="invalid-feedback">{errors.requiredByDays}</div>
                      )}
                    </div>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriorityListLayer;